import React, { useEffect, useState } from 'react'

export interface ISvrReportJson {
    ComputedData: ComputedData[]
}

export interface ComputedData {
    data:{
        MeasureName: string
        DataPoint: string
        UserVuTarget: UserVuTarget
        RubricRange: string
    }
}

export interface UserVuTarget {
    Condition: string
    Value: string
}
const SingleValueReportVU = (props: {
    vuId: number
    tableJSOnData: { [s: string]: any } | undefined
    drillThruDpList: any
    openDrillThru: Function
}) => {
    const { vuId, tableJSOnData, drillThruDpList, openDrillThru } = props
    const [tableRowData, setTableRowData] = useState<any[]>([])
    const formTableValues = (data: any, minLength: number) => {
        const result = []
        let startIndex = 0
        const content = data || []
        for (const outItr of content) {
            const { length } = outItr

            // Skip rows that match `minLength`
            if (length === minLength) continue

            // Calculate metaData
            const metaData = drillThruDpList?.slice(startIndex, startIndex + length - minLength)

            // Update startIndex
            startIndex += length - minLength

            // Add transformed row to result
            result.push({ data: outItr, metaData })
        }
        return result
    }
    useEffect(() => {
        let ComputedData: any = tableJSOnData?.ComputedData
        if (ComputedData) {
            createVuTableData(ComputedData)
        } else if (tableJSOnData && Object.keys(tableJSOnData).length > 0) {
            createVuTableData(tableJSOnData)
        }
    }, [tableJSOnData])
    
    const createVuTableData = (ComputedData: { [s: string]: any }) => {
        let minLength = 0
        const staticHeadersVal = ComputedData?.Headers?.filter(
            (item: any) => typeof item === 'string'
        )
        const dynamicHeaders = ComputedData?.Headers?.some(
            (item: any) => typeof item === 'object'
        )
        if (dynamicHeaders) {
            minLength = staticHeadersVal?.length ?? 0
        }
        const tableContentDpList = formTableValues(ComputedData, minLength)
        setTableRowData(tableContentDpList)
    }

    return (
        <div>
            <div
                id={'dashboard_vu_data_' + vuId}
                className="dashboard-vu-summary-data hide"
                style={{ display: 'block', opacity: 1, minHeight: '0px' }}
            >
                <div
                    id={'vu_table_wrapper_' + vuId}
                    className="vu-table-wrapper-svu"
                    style={{ position: 'static' }}
                >
                    <table id={'vu_table_' + vuId} className="vu-table-svu table table-hover">
                        <tbody id={'measure_table_body_' + vuId}>
                            {tableRowData.length > 0 &&
                                tableRowData.map((itr: ComputedData, index: number) => {
                                    return (
                                        <tr
                                            className="cursor-pointer"
                                            id={`new_summary_${vuId}_${index}`}
                                            key={`new_summary_${vuId}_${index}`}
                                        >
                                            <td>
                                                <b>{itr.data?.MeasureName}</b>:
                                            </td>
                                            <td
                                                onClick={() =>
                                                    openDrillThru(
                                                        drillThruDpList[index],
                                                        itr.data?.DataPoint
                                                    )
                                                }
                                                id={`td_${vuId}_0_1`}
                                                className="measureValue vu-drill-cell"
                                            >
                                                {itr.data?.DataPoint}
                                            </td>
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default SingleValueReportVU
